<template>
  <div :class="$style.container">
    <div :class="$style.preview">
      <base-icon
        v-p-t="4"
        v-color:black-2
        name="shopping_percent"
      ></base-icon>
    </div>
    <div :class="$style.content">
      <div
        v-m-b="10"
        :class="$style.title"
        v-text="$t('commission.of.service')"
      ></div>
      <div
        :class="$style.commission"
        v-text="displayAmount"
      ></div>
    </div>
  </div>
</template>

<script>
import { formatAmount } from 'lib/utils/amount';

export default {
  name: 'TransactionCommission',
  props: {
    commission: {
      type: Number,
      required: true,
    },
    currency: {
      type: Object,
      required: true,
    },
  },
  computed: {
    displayAmount() {
      return formatAmount(this.commission, this.currency);
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox

  .preview
    +flexbox
    +align-self(flex-start)
    flex: none
    margin-right: 26px

  .content
    flex: 1

  .title
    +font-type('medium', 12, 20)
    color: #212121
    opacity: .5

  .commission
    +font-type('medium', 20, 30)
    color: #212121
</style>
